require('./dist').register();



//////////////////
// WEBPACK FOOTER
// ./~/@kadira/storybook-addon-actions/register.js
// module id = 628
// module chunks = 0